import React from 'react';
import i18n from 'i18next';
import { sendLiveRegionMessage } from '../../components/atoms/LiveRegionGlobal/LiveRegionGlobal';
import { Namespace } from '../../translation/namespace';

function copy(data: ClipboardItem) {
  if (navigator) {
    try {
      navigator.clipboard.write([data]).then(() => {
        sendLiveRegionMessage(i18n.t(`${Namespace.phrases}:contentCopiedToClipboard`));
      });
    } catch {
      // ignore: for use of ClipboardItem in firefox dom.events.asyncClipboard.clipboardItem has to be set to true
    }
  }
}

export function writeTextToClipBoard(text: string) {
  return () => {
    copy(new ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }) }));
  };
}

export function copyHtml(elementRef: React.RefObject<HTMLDivElement | null>) {
  return () => {
    if (elementRef.current) {
      copy(
        new ClipboardItem({
          'text/html': new Blob([elementRef.current.innerHTML], { type: 'text/html' }),
          'text/plain': new Blob([elementRef.current.innerText], { type: 'text/plain' }),
        })
      );
    }
  };
}
